import { HamburgerMenuIcon, HelpIconThin, palette } from "../components/board/icons";
import { ToolButton } from "../components/board/ToolButton";
import { t } from "../utils/i18n";
import { showSelectedShapeActions, getNonDeletedElements } from "../element";
import { register } from "./register";
import { KEYS } from "../utils/keys";
import { StoreAction } from "../utils/store";

export const actionToggleCanvasMenu = register({
  name: "toggleCanvasMenu",
  label: "buttons.menu",
  trackEvent: { category: "menu" },
  perform: (_, appState) => ({
    appState: {
      ...appState,
      openMenu: appState.openMenu === "canvas" ? null : "canvas",
    },
    storeAction: StoreAction.NONE,
  }),
  PanelComponent: ({ appState, updateData }) => (
    <ToolButton
      type="button"
      icon={HamburgerMenuIcon}
      aria-label={t("buttons.menu")}
      onClick={updateData}
      selected={appState.openMenu === "canvas"}
    />
  ),
});

export const actionToggleEditMenu = register({
  name: "toggleEditMenu",
  label: "buttons.edit",
  trackEvent: { category: "menu" },
  perform: (_elements, appState) => ({
    appState: {
      ...appState,
      openMenu: appState.openMenu === "shape" ? null : "shape",
    },
    storeAction: StoreAction.NONE,
  }),
  PanelComponent: ({ elements, appState, updateData }) => (
    <ToolButton
      visible={showSelectedShapeActions(
        appState,
        getNonDeletedElements(elements),
      )}
      type="button"
      icon={palette}
      aria-label={t("buttons.edit")}
      onClick={updateData}
      selected={appState.openMenu === "shape"}
    />
  ),
});

export const actionShortcuts = register({
  name: "toggleShortcuts",
  label: "welcomeScreen.defaults.helpHint",
  icon: HelpIconThin,
  viewMode: true,
  trackEvent: { category: "menu", action: "toggleHelpDialog" },
  perform: (_elements, appState, _, { focusContainer }) => {
    if (appState.openDialog?.name === "help") {
      focusContainer();
    }
    return {
      appState: {
        ...appState,
        openDialog:
          appState.openDialog?.name === "help"
            ? null
            : {
              name: "help",
            },
      },
      storeAction: StoreAction.NONE,
    };
  },
  keyTest: (event) => event.key === KEYS.QUESTION_MARK,
});

export const actionAnimateShow = register({
  name: "animateShow",
  label: "buttons.animateShow",
  viewMode: true,
  trackEvent: { category: "menu" },
  perform: (_, appState) => {
    window.open(window.location.origin + "/animate?did=" + appState.id);
    return {
      storeAction: StoreAction.NONE,
    };
  },
  keyTest: (event) => event.key === KEYS.F && !event[KEYS.CTRL_OR_CMD],
});

export const actionOpenManage = register({
  name: "openManage",
  label: "buttons.openManage",
  viewMode: true,
  trackEvent: { category: "menu" },
  perform: (_, appState) => {
    window.open(window.location.origin + "/manage")
    return {
      storeAction: StoreAction.NONE,
    };
  },
  keyTest: (event) => event.key === KEYS.M && !event[KEYS.CTRL_OR_CMD],
});